import React from "react";

import {
  BoxContainer,
  BoxSkeleton,
  TabsParentContainer,
  TitleContainer,
} from "./styles";

const colors = [
  "rgb(156, 220, 231)", // nth-child(1)
  "rgb(226, 206, 242)", // nth-child(2)
  "rgb(248, 217, 191)", // nth-child(3)
  "rgb(238, 214, 214)", // nth-child(4)
  "rgb(203, 236, 195)", // nth-child(5)
  "rgb(254, 236, 175)", // nth-child(6)
  "rgb(255, 234, 234)", // nth-child(7)
  "#c7dfd4", // nth-child(8)
  "#f0f0f0", // nth-child(9)
];

const CareOpportunityTabs = ({
  tabs,
  activeIndex,
  handleTabChange,
  loadingTabs,
}) => {
  return (
    <TabsParentContainer>
      {loadingTabs
        ? Array.from(new Array(3)).map((_, index) => (
            <BoxSkeleton key={index} variant="rectangular" />
          ))
        : tabs.map((item, index) => (
            <BoxContainer
              key={index}
              sx={{
                backgroundColor: colors[index],
                outlineColor:
                  activeIndex === index ? colors[index] : "transparent",
              }}
              onClick={() => handleTabChange(index, item.care_oppt_category)}
            >
              <TitleContainer fontWeight={500} variant="body1">
                {item.care_oppt_category}
              </TitleContainer>
              <TitleContainer fontWeight={500} variant="body1">
                {item.count}
              </TitleContainer>
            </BoxContainer>
          ))}
    </TabsParentContainer>
  );
};

export default CareOpportunityTabs;
